module.exports = __webpack_public_path__ + "img/DigiQ.0fba2f4d.png";